import { useState, type FormEvent } from 'react';
import { createCreditCard } from '@/db/repositories/creditCardRepository';
import type { Model } from '../viewer/lib/model';
import { Actions, Field, Modal, field, parseAmount } from './ui';

export function CardForm({ model, onClose, onSaved }: { model: Model; onClose: () => void; onSaved: () => Promise<void> }) {
  const [name, setName] = useState('');
  const [limit, setLimit] = useState('');
  const [closingDay, setClosingDay] = useState('1');
  const [dueDay, setDueDay] = useState('10');
  // Vencimento em dias úteis (ADR 0082/0230): o mesmo interruptor do CardDialog da tela Cartões.
  const [businessDay, setBusinessDay] = useState(false);
  const [paymentAccountId, setPaymentAccountId] = useState(model.accounts[0]?.id ?? '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    const creditLimit = limit.trim() ? parseAmount(limit) : 0;
    const closing = Number(closingDay); const due = Number(dueDay);
    if (!name.trim()) { setError('Dê um nome ao cartão.'); return; }
    if (!(closing >= 1 && closing <= 31 && due >= 1 && due <= 31)) { setError('Dias de fechamento e vencimento entre 1 e 31.'); return; }
    setBusy(true); setError(null);
    try {
      await createCreditCard({ name: name.trim(), creditLimit: Number.isFinite(creditLimit) ? creditLimit : 0, closingDay: closing, dueDay: due, dueOnBusinessDay: businessDay ? 1 : 0, paymentAccountId: paymentAccountId || null } as Parameters<typeof createCreditCard>[0]);
      await onSaved();
    } catch (err) { setError(err instanceof Error ? err.message : String(err)); setBusy(false); }
  }

  return (
    <Modal title="Novo cartão" onClose={onClose} testId="card-form">
      <form onSubmit={submit} className="mt-4 space-y-4">
        <Field text="Nome"><input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex.: Nubank Platinum" className={field} autoFocus data-testid="card-name" /></Field>
        <Field text="Limite"><input inputMode="decimal" value={limit} onChange={(e) => setLimit(e.target.value)} placeholder="0,00" className={field} /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field text="Dia do fechamento"><input type="number" min={1} max={31} value={closingDay} onChange={(e) => setClosingDay(e.target.value)} className={field} /></Field>
          <Field text="Dia do vencimento"><input type="number" min={1} max={31} value={dueDay} onChange={(e) => setDueDay(e.target.value)} className={field} /></Field>
        </div>
        <button type="button" role="switch" aria-checked={businessDay} className="gl-switch" onClick={() => setBusinessDay((v) => !v)} data-testid="card-business-day">
          <span><strong>Vencimento em dias úteis</strong><small>Pula fim de semana e feriado.</small></span>
          <i aria-hidden="true"><b /></i>
        </button>
        <Field text="Conta que paga a fatura"><select value={paymentAccountId} onChange={(e) => setPaymentAccountId(e.target.value)} className={field}><option value="">Nenhuma</option>{model.accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></Field>
        {error && <p className="rounded-xl bg-neg-pale px-3 py-2 text-[13px] text-neg">{error}</p>}
        <Actions busy={busy} onCancel={onClose} submitLabel="Criar cartão" />
      </form>
    </Modal>
  );
}
